export const LOCATION_ROUTES = [
  {
    path: 'locations/create',
    name: 'CreateLocation',
    component: () => import('./views/CreateLocation.vue'),
  },
  {
    path: 'locations/:id/edit',
    name: 'EditLocation',
    component: () => import('./views/EditLocation.vue'),
  },
  {
    path: 'locations',
    name: 'LocationList',
    component: () => import('./views/LocationList.vue'),
  },
]
